import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import ReactToPrint from "react-to-print";
import {
  getSalesReportByInvoiceCount,
  getSalesReport,
  getSalesReportP,
  getCashRegister,
} from "../../../actions/report";
import { getAllOutlet, getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllAccount } from "../../../actions/accountsAction";
import { createjournals } from "../../../actions/journalAction"
import moment from "moment";

import Linechart from "../linechart";
import DemoDualAxes from "./Doublechart";
import RenderTable from "./RenderTable";
import Excelldownload from "./Excelldownload";
import dateFormat from "dateformat";
import CashRegister from "./CashRegister";

import { Layout, Breadcrumb, Row, Col, DatePicker, TimePicker, Space, Select, Divider, Skeleton, Card, Button, AutoComplete, Badge, Avatar, Spin,Table, InputNumber, Form} from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const CashRegisterReport = ({ getCashRegister, getSalesReport, getSalesReportP, getAllOutlet, getAllLocationPlain, getAllAccount, businessprofile, Auth, createjournals,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [accounts, setaccounts] = useState([]);
  const [outletlist, setoutletlist] = useState([]);
  const [loading, setloading] = useState(true);
  const [reload, setreload] = useState(false);
  const [type, setType] = useState("date");
  const from = useRef("2021-01-01");
  const to = useRef("2071-01-01");
  const start = useRef("");
  const end = useRef("");
  const cashin = useRef(0);
  const cashout = useRef(0);
  const account = useRef("");
  const location = useRef(Auth.profile.branch.id);
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_payments = useRef([]);
  let total_data = useRef({});
  const [form] = Form.useForm();

  useEffect(() => {
    getAllLocationPlain().then((result) => {
      setoutletlist(result);
    });

    getAllAccount().then((result) => {
      setaccounts(result);
    });
    if(start.current != "" && end.current != "" && location.current != ""){
      getCashRegister(
        start.current,
        end.current,
        location.current,
      ).then((result)=> {
        // console.log(result.data)
        setData(result.data);
        setloading(false);
      });
    }
  }, [reload]);

  const onSubmit = (type, amountt) => {
    // alert(amountt)
    let details = type
    let details2 = type
    let amount = parseFloat(amountt)
    let increase = true
    let destination = 0
    let source = 0
    if (type == "Cash in from office"){
      source = 5
      increase = true
      details2 = "Cash out to outlet"
      destination = 3
    }else if (type == "Cash out to office"){
      source = 5
      increase = false
      details2 = "Cash in from outlet"
      destination = 3
    }
    

    let formdata = new FormData();
    formdata.append("chartofaccount", 7)
    formdata.append("outlet", destination)
    formdata.append("employe", Auth.profile.id)
    formdata.append("account", 1)
    formdata.append("details", details)
    formdata.append("amount", amount)
    formdata.append("increase", increase)
    createjournals(formdata).then(res => {
      formdata.append("details", details2)
      formdata.append("outlet", source)
      formdata.append("increase", !increase)
      createjournals(formdata).then(response => {
        setreload(!reload)
      });
    })
  }
  

  const SwitchablePicker = () => {
    return (
      <Row wrap={false}>
        
        <Col span={5}>
        <h5>Issue date :</h5>
          <RangePicker
            style={{ width: "100%" }}
            picker={type}
            onChange={(value) => {
              if (value) {
                console.log(value);
                from.current = value[0].format("YYYY-MM-DD");
                to.current = value[1].format("YYYY-MM-DD");
                start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                // setreload(!reload);
              }
            }}
          />
         
        </Col>
        
        <Col span={4}>
        <h5>Outlet:</h5> 
          <Select
            placeholder="Please select a outlet"
            style={{ width: "100%" }}
            defaultValue={
              Auth.profile.branch.is_outlet ? Auth.profile.branch.id : ""
            }
            disabled={
              Auth.superuser
                ? false
                : true
            }
            onChange={(e) => {
              console.log(e);
              location.current = e;
              // setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            {outletlist.map((outlet) => {
              return <Option value={outlet.id}>{outlet.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={2}>
        <h5 style={{color:"white"}}> .</h5> 
          <Button type="primary" style={{ width: "100%", marginRight: "4px" }} onClick={() => {
            setloading(true);
            setreload(!reload);
          }}>Search</Button>
        </Col>
        
        <Col span={2}>
        <h5 style={{color:"white"}}> .</h5> 
          <ReactToPrint
            trigger={() => (
              <Button type="ghost" style={{ width: "100%", marginLeft: "4px" }}>
                Print
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>
    );
  };
  


  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row>
          <Col span={24}>{SwitchablePicker()}</Col>
          <Col
            span={12}
            style={{ padding: "1rem", border: "1px solid whitesmoke" }}
          >
            {/* {SwitchablePicker()} */}
            {location.current == 5 &&
              <>
                <Divider />
                <p>Cash out to outlet</p>
                <InputNumber min={0} onChange={(e)=>{
                  cashin.current = e
                }}></InputNumber>
                <Button type="primary" style={{marginTop: "10px"}} onClick={() => {
                  onSubmit("Cash in from office", cashin.current)
                }}>Submit</Button>
              </>
            }
            <Divider />
            <h3 style={{marginBottom: "10px"}}>Cash Register</h3>
            <table style={{width: "100%", border: "1px solid gray", padding: "10px"}}>
             
                <tr>
                   {/* <th> */}
                  <td style={{padding: "10px"}}><b>Head</b></td>
                  <td style={{padding: "10px"}}><b>Amount</b></td>
                  {/* </th> */}
                </tr>
              
              <tbody>
              {data.map(item => {
                if (item.type == "cashregister")
                  return <tr>
                  <td style={{padding: "10px"}}>{item.name}</td>
                  <td style={{padding: "10px"}}>{item.amount}</td>
                  </tr>
              })}
              </tbody>
            </table>
            
            {/* <Spin spinning={loading} >
              <RenderTable
                List={data}
                pageno={pageno}
                page_size={page_size}
                setreload={setreload}
                reload={reload}
                setloading={setloading}
                total_data={total_data}
              />
            </Spin> */}
            {location.current == 3 &&
              <>
              <Divider />
              <p>Cash out to office</p>
              <InputNumber min={0} onChange={(e)=>{
                cashout.current = e
              }}></InputNumber>
              <Button type="primary" style={{marginTop: "10px"}} onClick={() => {
                onSubmit("Cash out to office", cashout.current)
              }}>Submit</Button>
              </>
            }
          </Col>
          <Col span={10} offset={2}>
            <Divider />
            <h3 style={{marginBottom: "10px"}}>Bank & MFS Payments</h3>
              <table style={{width: "100%", border: "1px solid gray", padding: "10px"}}>
              
                  <tr>
                    {/* <th> */}
                    <td style={{padding: "10px"}}><b>Head</b></td>
                    <td style={{padding: "10px"}}><b>Amount</b></td>
                    {/* </th> */}
                  </tr>
                
                <tbody>
                {data.map(item => {
                  if (item.type == "bankregister")
                    return <tr>
                    <td style={{padding: "10px"}}>{item.name}</td>
                    <td style={{padding: "10px"}}>{item.amount}</td>
                    </tr>
                })}
                </tbody>
              </table>
                <Divider />
              {/* <h3 style={{marginBottom: "10px"}}>Invetory</h3>
              <table style={{width: "100%", border: "1px solid gray", padding: "10px"}}>
              
                  <tr>
                    <td style={{padding: "10px"}}><b>Head</b></td>
                    <td style={{padding: "10px"}}><b>Amount</b></td>
                  </tr>
                
                <tbody>
                {data.map(item => {
                  if (item.type == "inventory")
                    return <tr>
                    <td style={{padding: "10px"}}>{item.name}</td>
                    <td style={{padding: "10px"}}>{item.amount}</td>
                    </tr>
                })}
                </tbody>
              </table> */}
              {/* <h3 style={{marginBottom: "10px"}}>Profit</h3>
              <table style={{width: "100%", border: "1px solid gray", padding: "10px"}}>
              
                  <tr>
                    <td style={{padding: "10px"}}><b>Head</b></td>
                    <td style={{padding: "10px"}}><b>Amount</b></td>
                  </tr>
                
                <tbody>
                {data.map(item => {
                  if (item.type == "profitnloss")
                    return <tr>
                    <td style={{padding: "10px"}}>{item.name}</td>
                    <td style={{padding: "10px"}}>{item.amount}</td>
                    </tr>
                })}
                </tbody>
              </table> */}
          </Col>
        </Row>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getCashRegister,
  getSalesReport,
  getSalesReportP,
  getAllOutlet,
  getAllAccount,
  getAllLocationPlain,
  createjournals,
})(CashRegisterReport);
